import {Icon} from '@wandb/weave/components/Icon';
import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback} from 'react';
import {Slide, toast} from 'react-toastify';

import * as S from './CodeSnippet.styles';

type CodeCopyButtonProps = {
  copyContent: string;
  analyticsEvent?: (data: any) => void;
  analyticsDefaultProperties?: Record<string, any>;
};

export const CodeCopyButton = ({
  copyContent,
  analyticsEvent,
  analyticsDefaultProperties,
}: CodeCopyButtonProps) => {
  const onCopyClick = useCallback(() => {
    copyToClipboard(copyContent);
    toast('Copied to clipboard', {
      transition: Slide,
    });

    analyticsEvent?.({
      ...analyticsDefaultProperties,
      codeSnippet: copyContent,
    });
  }, [copyContent, analyticsEvent, analyticsDefaultProperties]);

  return (
    <S.CodeCopyButton onClick={onCopyClick}>
      <S.IconContainer>
        <Icon name="copy" /> Copy
      </S.IconContainer>
    </S.CodeCopyButton>
  );
};
